import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { api_routes, db_tables } from '@app/consts';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { TranslateService } from '@ngx-translate/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { ImportsService } from '../../services/imports.service';
import { GridState } from '@app/shared/services/grid-state/grid-state.model';
import { from } from 'rxjs';
import { ImportLog } from '../../models/imports.model';

@Component({
  selector: 'app-import-log-data-grid',
  templateUrl: './import-log-data-grid.component.html',
  styleUrls: ['./import-log-data-grid.component.scss']
})
export class ImportLogDataGridComponent implements OnInit {
  @Input() importId: string;
  @ViewChild('excelexport') excelexport: any;

  excelColumns: any[] = [
    { field: 'runTime', title: this.translate.instant('ImportRunTime') },
    { field: 'row', title: this.translate.instant('ImportRow') },
    { field: 'column', title: this.translate.instant('ImportColumn') },
    { field: 'logType.name', title: this.translate.instant('ImportLogType') },
    { field: 'message', title: this.translate.instant('ImportMessage') },
  ];

  public columns: any[] = [
    { field: "runTime", title: "Run Time", localizationCode: "ImportRunTime", type: "dateTime" },
    { field: "row", title: "Row", localizationCode: "ImportRow" },
    { field: "column", title: "Column", localizationCode: "ImportColumn" },
    { field: "logType", subField: "name", title: "Log Type", localizationCode: "ImportLogType" },
    { field: "message", title: "Message", localizationCode: "ImportMessage" },
  ];

  filterCategories: any[] = [
    { field: "runTime", title: "Run Time", localizationCode: "ImportRunTime", dataType: "Date" },
    { field: "row", title: "Row", localizationCode: "ImportRow", dataType: "Number" },
    { field: "column", title: "Column", localizationCode: "ImportColumn", dataType: "String" },
    { field: "message", title: "Message", localizationCode: "ImportMessage", dataType: "String" },
    { field: "logType.name", title: "Log Type", localizationCode: "ImportLogType", dataType: "String" },
  ];

  sortableColumns: any[] = [
    { field: "runTime", sortValue: "runTime" },
    { field: "row", sortValue: "row" },
    { field: "column", sortValue: "column" },
    { field: "message", sortValue: "message" },
    { field: "logType", sortValue: "logType.name" }
  ];

  public gridDataResult: GridDataResult;
  public api_routes = api_routes;
  public db_tables = db_tables;
  isLoading: boolean = true;
  pageSize: number = 20;
  skip: number = 0;
  sortString: string = 'RunTime-desc';
  filterString: string;
  gridId: string;
  getRequest: any;
  excelData: ImportLog[];
  fileName: string = 'Import-Data-Log.xlsx';
  

  constructor(
    private overlayService: OverlayService,
    public translate: TranslateService,
    private snackbarService: SnackbarService,
    private importsService: ImportsService,
  ) {
    this.gridId = `importLogGrid_${this.importId}`;
  }

  ngOnInit(): void {
    this.getImports();
  }

  getImports() {
    this.isLoading = true;

    let filter = `(import.id = "${this.importId}")` + (this.filterString ? ` AND (${this.filterString})` : '');

    this.getRequest = this.importsService.getImportLogs(this.pageSize, this.skip, this.sortString, filter)
      .subscribe(
        {
          next: (v) => {
            this.gridDataResult = {
              data: v.data,
              total: v.total
            };
            this.isLoading = false;
          },
          error: (e) => { this.overlayService.hide(); this.isLoading = false; },
          complete: () => this.overlayService.hide()
        }
      );
  }

  public allData() {
    this.overlayService.show('Loading');

    from(this.importsService.getAllImportLogs(this.sortString, this.filterString))
      .subscribe({
        next: (res) => {
          this.excelData = res.data;

          // this.excelData.map((item) => {
          //   item.employee = `${item.employee.firstName} ${item.employee.lastName}`;
          //   item.timeOffType = item.timeOffType?.name;

          //   if (item.currency?.id) {
          //     item.salary = this.currencyPipe.transform(item.salary, item.currency.id, 'symbol', '1.2-2');
          //     item.quarterlyTotal = this.currencyPipe.transform(item.quarterlyTotal, item.currency.id, 'symbol', '1.2-2');
          //   }
          // });

          // if I dont have this timeout first time I download the report the data will be blank
          setTimeout(() => {
            this.excelexport.save();
          }, 1000);
        },
        error: (e) => {
          this.overlayService.hide();
        },
        complete: () => this.overlayService.hide()
      });
  }

  gridStateChange(gridState: GridState) {
    if (this.pageSize !== gridState.pageSize) {
      this.pageSize = gridState.pageSize;
    }
    if (this.skip !== gridState.skip) {
      this.skip = gridState.skip;
    }
    if (this.sortString !== gridState.sortString) {
      this.sortString = gridState.sortString;
    }
    if (this.filterString !== gridState.filter) {
      this.filterString = gridState.filter;
      this.skip = 0;
    }

    this.getRequest.unsubscribe();
    this.getImports();
  }

}
